import script from "./ConflictBackupPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ConflictBackupPanel.vue?vue&type=script&setup=true&lang=js"

import "./ConflictBackupPanel.vue?vue&type=style&index=0&id=6ba13266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba13266"]])

export default __exports__